// Translation data for 5 languages: Icelandic, English, Polish, Lithuanian, Russian
export const translations = {
  is: {
    // Navigation
    'registration': 'Ný skráning',
    'calendar': 'Dagatal',
    'jobs': 'Verk',
    'payments': 'Greiðslur', 
    'dealerships': 'Bílasölur',
    'reports': 'Skýrslur',
    'customers': 'Viðskiptavinir',
    'store': 'Verslun',
    'pricelist': 'Verðskrá',
    'products': 'Vörunotkun',
    'inventory': 'Lager',
    'accounting': 'Bókhaldskerfið',
    'users': 'Notendur',
    'settings': 'Stillingar',
    'logout': 'Útskrá',
    
    // Form fields
    'phone_number': 'Símanúmer',
    'owner_name': 'Nafn eiganda',
    'owner_kt': 'Kennitala eiganda',
    'license_plate': 'Númeraplata',
    'license_plate_placeholder': 'ABC12 - Sækir upplýsingar sjálfkrafa',
    'car_make': 'Bílaframleiðandi',
    'car_model': 'Bílategund',
    'car_size': 'Stærð bíls',
    'select_size': 'Veldu stærð',
    'dealership': 'Bílasala',
    'select_dealership': 'Veldu bílasölu (valkvætt)',
    'expected_date': 'Áætluð dagsetning',
    'services': 'Þjónusta',
    'select_services': 'Veldu þjónustu',
    'notes': 'Athugasemdir',
    'email': 'Netfang',
    'password': 'Lykilorð',
    'name': 'Nafn',
    'role': 'Hlutverk',
    'company': 'Fyrirtæki',
    'address': 'Heimilisfang',
    'completed_jobs': 'Lokin verk',
    'all_jobs': 'Öll verk',
    'today': 'Í dag',
    'this_week': 'Í vikunni',
    'this_month': 'Í mánuðinum',
    'last_7_days': 'Síðustu 7 dagar',
    'last_30_days': 'Síðustu 30 dagar',
    'custom_range': 'Sérsniðið tímabil',
    
    // Table headers
    'date': 'Dagsetning',
    'time': 'Tími',
    'owner': 'Eigandi',
    'status': 'Staða',
    'price': 'Verð',
    'total': 'Samtals',
    'actions': 'Aðgerðir',
    'created': 'Stofnað',
    'updated': 'Uppfært',
    
    // Status values
    'pending': 'Í bið',
    'in_progress': 'Í vinnslu',
    'done': 'Lokið',
    'cancelled': 'Hætt við',
    'paid': 'Greitt',
    'unpaid': 'Ógreitt',
    'active': 'Virkt',
    'inactive': 'Óvirkt',
    
    // Common actions
    'save': 'Vista',
    'cancel': 'Hætta við',
    'edit': 'Breyta',
    'delete': 'Eyða',
    'create': 'Búa til',
    'submit': 'Senda',
    'add': 'Bæta við',
    'update': 'Uppfæra',
    'close': 'Loka',
    'confirm': 'Staðfesta',
    'search': 'Leita',
    'filter': 'Sía',
    'clear': 'Hreinsa',
    'reset': 'Endurstilla',
    'export': 'Flytja út',
    'print': 'Prenta',
    'download': 'Sækja',
    'upload': 'Hlaða upp',
    'view': 'Skoða',
    'details': 'Upplýsingar',
    'back': 'Til baka',
    'next': 'Áfram',
    'previous': 'Fyrri',
    'yes': 'Já',
    'no': 'Nei',
    
    // Messages
    'loading': 'Hleður...',
    'no_results': 'Engar niðurstöður',
    'no_data': 'Engin gögn',
    'error': 'Villa',
    'success': 'Tókst',
    'warning': 'Viðvörun',
    'info': 'Upplýsingar',
    'required': 'Nauðsynlegt',
    'optional': 'Valkvætt',
    
    // SMS
    'sms_notifications': 'SMS Tilkynningar',
    'send_completion_sms': 'Senda SMS þegar bíll er tilbúinn',
    'send_payment_sms': 'Senda SMS með greiðslulink (ef ekki reikningsviðskipti)',
    'sms_will_be_sent': 'SMS verður sent á'
  },
  en: {
    // Navigation  
    'registration': 'New Registration',
    'calendar': 'Calendar',
    'jobs': 'Jobs',
    'payments': 'Payments',
    'dealerships': 'Dealerships', 
    'reports': 'Reports',
    'customers': 'Customers',
    'pricelist': 'Price List',
    'inventory': 'Inventory',
    'accounting': 'Accounting',
    'users': 'Users',
    'settings': 'Settings',
    'logout': 'Logout',
    
    // Form fields
    'phone_number': 'Phone Number',
    'owner_name': 'Owner Name',
    'owner_kt': 'Owner ID',
    'license_plate': 'License Plate',
    'license_plate_placeholder': 'ABC12 - Auto-fetches information',
    'car_make': 'Car Make',
    'car_model': 'Car Model',
    'car_size': 'Car Size',
    'select_size': 'Select Size',
    'dealership': 'Dealership',
    'select_dealership': 'Select Dealership (optional)',
    'expected_date': 'Expected Date',
    'services': 'Services',
    'select_services': 'Select Services',
    'notes': 'Notes',
    'email': 'Email',
    'password': 'Password',
    'name': 'Name',
    'role': 'Role',
    'company': 'Company',
    'address': 'Address',
    'completed_jobs': 'Completed Jobs',
    'all_jobs': 'All Jobs',
    'today': 'Today',
    'this_week': 'This Week',
    'this_month': 'This Month',
    'last_7_days': 'Last 7 Days',
    'last_30_days': 'Last 30 Days',
    'custom_range': 'Custom Range',
    
    // Table headers
    'date': 'Date',
    'time': 'Time',
    'owner': 'Owner',
    'status': 'Status',
    'price': 'Price',
    'total': 'Total',
    'actions': 'Actions',
    'created': 'Created',
    'updated': 'Updated',
    
    // Status values
    'pending': 'Pending',
    'in_progress': 'In Progress',
    'done': 'Done',
    'cancelled': 'Cancelled',
    'paid': 'Paid',
    'unpaid': 'Unpaid',
    'active': 'Active',
    'inactive': 'Inactive',
    
    // Common actions
    'save': 'Save',
    'cancel': 'Cancel',
    'edit': 'Edit',
    'delete': 'Delete',
    'create': 'Create',
    'submit': 'Submit',
    'add': 'Add',
    'update': 'Update',
    'close': 'Close',
    'confirm': 'Confirm',
    'search': 'Search',
    'filter': 'Filter',
    'clear': 'Clear',
    'reset': 'Reset',
    'export': 'Export',
    'print': 'Print',
    'download': 'Download',
    'upload': 'Upload',
    'view': 'View',
    'details': 'Details',
    'back': 'Back',
    'next': 'Next',
    'previous': 'Previous',
    'yes': 'Yes',
    'no': 'No',
    
    // Messages
    'loading': 'Loading...',
    'no_results': 'No results',
    'no_data': 'No data',
    'error': 'Error',
    'success': 'Success',
    'warning': 'Warning',
    'info': 'Information',
    'required': 'Required',
    'optional': 'Optional',
    
    // SMS
    'sms_notifications': 'SMS Notifications',
    'send_completion_sms': 'Send SMS when car is ready',
    'send_payment_sms': 'Send SMS with payment link (if not invoice)',
    'sms_will_be_sent': 'SMS will be sent to'
  },
  pl: {
    // Navigation
    'registration': 'Nowa Rejestracja',
    'calendar': 'Kalendarz',
    'jobs': 'Prace',
    'payments': 'Płatności',
    'dealerships': 'Dealerzy',
    'reports': 'Raporty',
    'customers': 'Klienci',
    'pricelist': 'Cennik',
    'inventory': 'Magazyn',
    'accounting': 'Księgowość',
    'users': 'Użytkownicy',
    'settings': 'Ustawienia',
    'logout': 'Wyloguj',
    
    // Form fields
    'phone_number': 'Numer Telefonu',
    'owner_name': 'Imię Właściciela',
    'owner_kt': 'ID Właściciela',
    'license_plate': 'Tablica Rejestracyjna',
    'car_make': 'Marka Samochodu',
    'car_model': 'Model Samochodu',
    'car_size': 'Rozmiar Samochodu',
    'dealership': 'Dealer',
    'expected_date': 'Oczekiwana Data',
    'services': 'Usługi',
    'select_services': 'Wybierz Usługi',
    'notes': 'Uwagi',
    'email': 'Email',
    'password': 'Hasło',
    'name': 'Nazwa',
    'role': 'Rola',
    'company': 'Firma',
    'address': 'Adres',
    
    // Table headers
    'date': 'Data',
    'time': 'Czas',
    'owner': 'Właściciel',
    'status': 'Status',
    'price': 'Cena',
    'total': 'Razem',
    'actions': 'Akcje',
    'created': 'Utworzono',
    'updated': 'Zaktualizowano',
    
    // Status values
    'pending': 'Oczekujące',
    'in_progress': 'W Toku',
    'done': 'Gotowe',
    'cancelled': 'Anulowane',
    'paid': 'Opłacone',
    'unpaid': 'Nieopłacone',
    'active': 'Aktywny',
    'inactive': 'Nieaktywny',
    
    // Common actions
    'save': 'Zapisz',
    'cancel': 'Anuluj',
    'edit': 'Edytuj',
    'delete': 'Usuń',
    'create': 'Utwórz',
    'submit': 'Wyślij',
    'add': 'Dodaj',
    'update': 'Aktualizuj',
    'close': 'Zamknij',
    'confirm': 'Potwierdź',
    'search': 'Szukaj',
    'filter': 'Filtruj',
    'clear': 'Wyczyść',
    'reset': 'Resetuj',
    'export': 'Eksportuj',
    'print': 'Drukuj',
    'download': 'Pobierz',
    'upload': 'Prześlij',
    'view': 'Zobacz',
    'details': 'Szczegóły',
    'back': 'Wstecz',
    'next': 'Dalej',
    'previous': 'Poprzedni',
    'yes': 'Tak',
    'no': 'Nie',
    
    // Messages
    'loading': 'Ładowanie...',
    'no_results': 'Brak wyników',
    'no_data': 'Brak danych',
    'error': 'Błąd',
    'success': 'Sukces',
    'warning': 'Ostrzeżenie',
    'info': 'Informacja',
    'required': 'Wymagane',
    'optional': 'Opcjonalne',
    
    // SMS
    'sms_notifications': 'Powiadomienia SMS',
    'send_completion_sms': 'Wyślij SMS po zakończeniu',
    'send_payment_sms': 'Wyślij SMS z linkiem płatności',
    'sms_will_be_sent': 'SMS zostanie wysłany do'
  },
  lt: {
    // Navigation
    'registration': 'Nauja Registracija',
    'calendar': 'Kalendorius',
    'jobs': 'Darbai',
    'payments': 'Mokėjimai',
    'dealerships': 'Prekybos Centrai',
    'reports': 'Ataskaitos',
    'customers': 'Klientai',
    'pricelist': 'Kainų Sąrašas',
    'inventory': 'Inventorius',
    'accounting': 'Apskaita',
    'users': 'Vartotojai',
    'settings': 'Nustatymai',
    'logout': 'Atsijungti',
    
    // Form fields
    'phone_number': 'Telefono Numeris',
    'owner_name': 'Savininko Vardas',
    'owner_kt': 'Savininko ID',
    'license_plate': 'Numerio Lentelė',
    'car_make': 'Automobilio Gamintojas',
    'car_model': 'Automobilio Modelis',
    'car_size': 'Automobilio Dydis',
    'dealership': 'Prekybos Centras',
    'expected_date': 'Numatoma Data',
    'services': 'Paslaugos',
    'select_services': 'Pasirinkite Paslaugas',
    'notes': 'Pastabos',
    'email': 'El. paštas',
    'password': 'Slaptažodis',
    'name': 'Vardas',
    'role': 'Vaidmuo',
    'company': 'Įmonė',
    'address': 'Adresas',
    
    // Table headers
    'date': 'Data',
    'time': 'Laikas',
    'owner': 'Savininkas',
    'status': 'Būsena',
    'price': 'Kaina',
    'total': 'Iš viso',
    'actions': 'Veiksmai',
    'created': 'Sukurta',
    'updated': 'Atnaujinta',
    
    // Status values
    'pending': 'Laukiama',
    'in_progress': 'Vykdoma',
    'done': 'Atlikta',
    'cancelled': 'Atšaukta',
    'paid': 'Apmokėta',
    'unpaid': 'Neapmokėta',
    'active': 'Aktyvus',
    'inactive': 'Neaktyvus',
    
    // Common actions
    'save': 'Išsaugoti',
    'cancel': 'Atšaukti',
    'edit': 'Redaguoti',
    'delete': 'Ištrinti',
    'create': 'Sukurti',
    'submit': 'Pateikti',
    'add': 'Pridėti',
    'update': 'Atnaujinti',
    'close': 'Uždaryti',
    'confirm': 'Patvirtinti',
    'search': 'Ieškoti',
    'filter': 'Filtruoti',
    'clear': 'Išvalyti',
    'reset': 'Atstatyti',
    'export': 'Eksportuoti',
    'print': 'Spausdinti',
    'download': 'Atsisiųsti',
    'upload': 'Įkelti',
    'view': 'Peržiūrėti',
    'details': 'Išsami informacija',
    'back': 'Atgal',
    'next': 'Toliau',
    'previous': 'Ankstesnis',
    'yes': 'Taip',
    'no': 'Ne',
    
    // Messages
    'loading': 'Kraunama...',
    'no_results': 'Nėra rezultatų',
    'no_data': 'Nėra duomenų',
    'error': 'Klaida',
    'success': 'Sėkmė',
    'warning': 'Įspėjimas',
    'info': 'Informacija',
    'required': 'Privaloma',
    'optional': 'Neprivaloma',
    
    // SMS
    'sms_notifications': 'SMS Pranešimai',
    'send_completion_sms': 'Siųsti SMS kai baigta',
    'send_payment_sms': 'Siųsti SMS su mokėjimo nuoroda',
    'sms_will_be_sent': 'SMS bus išsiųstas į'
  },
  ru: {
    // Navigation
    'registration': 'Новая Регистрация',
    'calendar': 'Календарь',
    'jobs': 'Работы',
    'payments': 'Платежи',
    'dealerships': 'Дилеры',
    'reports': 'Отчеты',
    'customers': 'Клиенты',
    'pricelist': 'Прайс-лист',
    'inventory': 'Склад',
    'accounting': 'Бухгалтерия',
    'users': 'Пользователи',
    'settings': 'Настройки',
    'logout': 'Выйти',
    
    // Form fields
    'phone_number': 'Номер Телефона',
    'owner_name': 'Имя Владельца',
    'owner_kt': 'ID Владельца',
    'license_plate': 'Номерной Знак',
    'car_make': 'Марка Автомобиля',
    'car_model': 'Модель Автомобиля',
    'car_size': 'Размер Автомобиля',
    'dealership': 'Дилер',
    'expected_date': 'Ожидаемая Дата',
    'services': 'Услуги',
    'select_services': 'Выберите Услуги',
    'notes': 'Примечания',
    'email': 'Электронная почта',
    'password': 'Пароль',
    'name': 'Имя',
    'role': 'Роль',
    'company': 'Компания',
    'address': 'Адрес',
    
    // Table headers
    'date': 'Дата',
    'time': 'Время',
    'owner': 'Владелец',
    'status': 'Статус',
    'price': 'Цена',
    'total': 'Итого',
    'actions': 'Действия',
    'created': 'Создано',
    'updated': 'Обновлено',
    
    // Status values
    'pending': 'Ожидание',
    'in_progress': 'В Процессе',
    'done': 'Готово',
    'cancelled': 'Отменено',
    'paid': 'Оплачено',
    'unpaid': 'Не оплачено',
    'active': 'Активный',
    'inactive': 'Неактивный',
    
    // Common actions
    'save': 'Сохранить',
    'cancel': 'Отмена',
    'edit': 'Редактировать',
    'delete': 'Удалить',
    'create': 'Создать',
    'submit': 'Отправить',
    'add': 'Добавить',
    'update': 'Обновить',
    'close': 'Закрыть',
    'confirm': 'Подтвердить',
    'search': 'Поиск',
    'filter': 'Фильтр',
    'clear': 'Очистить',
    'reset': 'Сбросить',
    'export': 'Экспорт',
    'print': 'Печать',
    'download': 'Скачать',
    'upload': 'Загрузить',
    'view': 'Просмотр',
    'details': 'Детали',
    'back': 'Назад',
    'next': 'Далее',
    'previous': 'Предыдущий',
    'yes': 'Да',
    'no': 'Нет',
    
    // Messages
    'loading': 'Загрузка...',
    'no_results': 'Нет результатов',
    'no_data': 'Нет данных',
    'error': 'Ошибка',
    'success': 'Успех',
    'warning': 'Предупреждение',
    'info': 'Информация',
    'required': 'Обязательно',
    'optional': 'Необязательно',
    
    // SMS
    'sms_notifications': 'SMS Уведомления',
    'send_completion_sms': 'Отправить SMS когда готово',
    'send_payment_sms': 'Отправить SMS со ссылкой на оплату',
    'sms_will_be_sent': 'SMS будет отправлено на'
  }
};

// Translation helper function
export const t = (key, language = 'is') => {
  return translations[language]?.[key] || translations.is[key] || key;
};
